// eslint-disable-next-line
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserProvider } from './component/common/UserContext';
import Layout from './component/Layout';
import CustomDropdown from './component/common/CustomDropdown';


import Login from './component/Login/Login';
import CompanyMaster from './component/CompanyMaster/CM';
import CMEDIT from './component/CompanyMaster/CMEdit';
import CMList from './component/CompanyMaster/CMList';

import UserMaster from './component/UserMaster/UM';
import UMList from './component/UserMaster/UMList';

import GM from './component/GroupMaster/GM';
import GMList from './component/GroupMaster/GMList';

import SCPConfig from './component/SCPConfigurationMaster/SCPConfig';
import SCPConfigList from './component/SCPConfigurationMaster/SCPConfigList';
import SCPConfigEdit from './component/SCPConfigurationMaster/SCPConfigEdit';

import RM from './component/RoutingMaster/RM';
import RMEdit from './component/RoutingMaster/RMEdit';
import RMList from './component/RoutingMaster/RMList';

import SCPMaster from './component/SCPMaster/SCPM';
import SCPMEdit from './component/SCPMaster/SCPMEdit';
import SCPMasterList from './component/SCPMaster/SCPMList';

import LGCM from './component/LogisticCompanyMaster/LGCM';
import LGCMList from './component/LogisticCompanyMaster/LGCMList';
import LGCMEdit from './component/LogisticCompanyMaster/LGCMEdit';

import CITPM from './component/CompanyITPolicyMaster/CITPM';
import CITPMLIST from './component/CompanyITPolicyMaster/CITPMLIST';
import CitpmEdit from './component/CompanyITPolicyMaster/CitpmEdit';

import LocationMaster from './component/LocationMaster/Locm';
import LocMasterList from './component/LocationMaster/LocMList';
import LocationMasterEdit from './component/LocationMaster/LocMEdit';

import CGM from './component/CompanyGroupMaster/CGM';
import CGMList from './component/CompanyGroupMaster/CGMList';
import CGMEDIT from './component/CompanyGroupMaster/CGMEdit';

//==================================
import ShipmentForm from './component/ShipmentOutwardCreation/SMOutward';
import ShipmentEdit from './component/ShipmentOutwardCreation/SMOutwardEdit';
import ShipmentList from './component/ShipmentOutwardCreation/SMOutwardList';
import ShipmentDetail from './component/ShipmentOutwardCreation/SMView';

import OrderForm from './component/Order Master by SCP/ORDM'

import EditOrderList from './component/Order Master by SCP/ORDMEdit'


import OrderList from './component/Order Master by SCP/ORDMList'



import OrdView from './component/Order Master by SCP/ORDVIEW';

import OrderReport from './component/Report/OrderReport'

import ShipmentReturn from './component/ShipmentReturn/SMReturn';
import ShipmentReturnList from './component/ShipmentReturn/SMReturnList';
import ShipmentReturnUpdate from './component/ShipmentReturn/SMReturnEdit';
import ShipmentReturnView from './component/ShipmentReturn/SMReturnView';

////===================== Shipment Scanning Process (UPDATED) =====================////
import ShipmentSelectScanType from './component/ShipmentScanningProcess/ShipmentSelectScanType';
import ShipInScanSearch from './component/ShipmentScanningProcess/ShipmentInwardScan/ShipInScanSearch';
import ShipOutScanSearch from './component/ShipmentScanningProcess/ShipmentOutwardScan/ShipOutScanSearch';
import ShipOutScanPendingList from './component/ShipmentScanningProcess/ShipmentOutwardScan/ShipOutScanPendingList';
import ShipOutScanByVendor from './component/ShipmentScanningProcess/ShipmentOutwardScan/ShipOutScanByVendor';
import ShipOutScanByProduct from './component/ShipmentScanningProcess/ShipmentOutwardScan/ShipOutScanByProduct';
import ShipOutScanedList from './component/ShipmentScanningProcess/ShipmentOutwardScan/ShipOutScanedList';
import ShipInScanedList from './component/ShipmentScanningProcess/ShipmentInwardScan/ShipInScanedList';
import ShipInScanPendingList from './component/ShipmentScanningProcess/ShipmentInwardScan/ShipInScanPendingList';
import ShipInScanByVendor from './component/ShipmentScanningProcess/ShipmentInwardScan/ShipInScanByVendor';
import ShipInScanByProduct from './component/ShipmentScanningProcess/ShipmentInwardScan/ShipInScanByProduct';
import ShipmentReportTable from './component/Report/ShipmentReport';
import AuditTrailReport from './component/Report/ATReport';

import ShipInReturnScan from './component/ShipmentScanningProcess/ShipmentInwardScan/ShipInReturnScan';
import ShipOutReturnScan from './component/ShipmentScanningProcess/ShipmentOutwardScan/ShipOutReturnScan';
////===================== Shipment Scanning Process (UPDATED) =====================////

import ShipmentReport from './component/Report/ShipmentReport';
import OrderVerification from './component/Rights/OrderVerification';
import EditOrderStatus from './component/Rights/EditOrderStatus';
import ReactGridLayout from './component/Charts/ReactGridLayout';
import OrderChart from './component/Charts/OrderChart';
import Widget from './component/Charts/Widget';
import ShipmentApproval from './component/ShipmentApproval/SM_Approval';
import ShipmentApprovalList from './component/ShipmentApproval/SM_ApprovalList';
import ShipmentReturnApproval from './component/ShipmentApproval/SM_ReturnApproval';
import Inventory from './component/Report/Inventory';


// import Home from './component/EmailConfiguration/EC_Main';
import List from './component/EmailConfiguration/EC_List';
import EmailEdit from './component/EmailConfiguration/EC_Edit';
import { useEffect } from 'react';


import Rsn from './component/RsnHistory/Rsn'
import AboutUs from './component/AboutUs/AboutUs';

import SessionTimeout from './component/SessionTimeout'
import Home from './component/Home';
import EmailConfiguration from './component/EmailConfiguration/EC_Main';
import SCT from './component/SupplyChainTransaction/SCT';

import SchemeMaster from './component/SchemeMaster/Scheme';
import SchemeList from './component/SchemeMaster/SchemeList';
import FullScreenSupplyChainMap from './component/SupplyChainTransaction/FullScreenSupplyChainMap';

import CCHome from './component/companyConfiguration/cchome';
import CCList from './component/companyConfiguration/cclist';
import CCView from './component/companyConfiguration/ccview';

function App() {

    const location = useLocation(); // Add this hook

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Prevent shortcut keys like Ctrl, Meta, Alt, and F12
      if (e.metaKey || e.altKey || e.key === "F12") {
        e.preventDefault();
      }
    };

    // Attach the event listener
    document.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    // Clear session storage value on page refresh
    sessionStorage.removeItem("selection");
  }, []);

  const handleContextMenu = (e) => {
    e.preventDefault(); // Disable right-click
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll("form").forEach((form) => {
        form.setAttribute("autocomplete", "off");
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect(); // Cleanup on unmount
  }, []);

  //   Simplified fullscreen effect
    // useEffect(() => {
    //     if (location.pathname === '/dashboard') {
    //         const enterFullscreen = async () => {
    //             try {
    //                 const element = document.documentElement;
    //                 if (element.requestFullscreen) {
    //                     await element.requestFullscreen();
    //                 }
    //             } catch (error) {
    //                 console.log('Fullscreen error:', error);
    //             }
    //         };
  
    //         enterFullscreen();
    //     }
    // }, [location.pathname]);


return (
    <div className="App"
      // autoComplete="off"
      // onKeyDown={handleKeyDown}
      onContextMenu={handleContextMenu}
    >
      <UserProvider>
       
        <Routes>
          <Route path='/' element={<Login />} />
<Route path="/:CompanyCode" element={<Login />} />
          <Route path='/ResetPassword' element={<Login />} />
          <Route path='/drop' element={<CustomDropdown />} />
          <Route path="/dashboard" element={<ReactGridLayout />} />
          {/* <Route path="/dashboard" element={<Layout><ReactGridLayout /></Layout>} /> */}
          <Route path="/home" element={<Layout><Home/></Layout>} />
          <Route path="/dashboard/shipmentreport" element={<Layout><ShipmentReport /></Layout>} />
          <Route path="/dashboard/inventory" element={<Layout><Inventory /></Layout>} />
          <Route path="/dashboard/about" element={<Layout><AboutUs/></Layout>} /> 
         

          <Route path='/dashboard/ReactGridLayout' element={<Layout><ReactGridLayout></ReactGridLayout></Layout>} />
          <Route path='/dashboard/Chart' element={<Layout><OrderChart></OrderChart></Layout>} />
          <Route path='/dashboard/Widgets' element={<Layout><Widget /></Layout>} />

          <Route path="/dashboard/shipmentapproval" element={<Layout><ShipmentApprovalList /></Layout>} />
          <Route path="/shipmentoutwardapproval/:shipmentCode" element={<Layout><ShipmentApproval /></Layout>} />
          <Route path="/shipmentreturnapproval/:shipmentCode" element={<Layout><ShipmentReturnApproval /></Layout>} />

          <Route path='/dashboard/companygroupmaster' element={<Layout><CGM /></Layout>} />
          <Route path='/cgmlist' element={<Layout><CGMList /></Layout>} />
          <Route path='/cgmedit/:CGM_ID' element={<Layout><CGMEDIT /></Layout>} />

          <Route path="/dashboard/scpmaster" element={<Layout><SCPMaster /></Layout>} />
          <Route path="/dashboard/:scpmlist" element={<Layout><SCPMasterList /></Layout>} />
          <Route path="/dashboard/:scpmedit/:SCPM_ID" element={<Layout><SCPMEdit /></Layout>} />

          <Route path='/dashboard/companymaster' element={<Layout><CompanyMaster /></Layout>} />
          <Route path='/cmlist' element={<Layout><CMList /></Layout>} />
          <Route path='/cmedit/:CM_ID' element={<Layout><CMEDIT /></Layout>} />


          <Route path='/dashboard/usermaster' element={<Layout><UserMaster /></Layout>} />
          <Route path='/umlist' element={<Layout><UMList /></Layout>} />

          <Route path='/dashboard/GroupM' element={<Layout><GM /></Layout>} />
          <Route path='/dashboard/GroupM/:groupId' element={<Layout><GM /></Layout>} />
          <Route path='/gmlist' element={<Layout><GMList /></Layout>} />

          <Route path="/dashboard/scpconfig" element={<Layout><SCPConfig /></Layout>} />
          <Route path="/scpconfiglist" element={<Layout><SCPConfigList /></Layout>} />
          <Route path="/scpconfigedit/:cgmId/:cgmCompanyName" element={<Layout><SCPConfigEdit /></Layout>} />

          <Route path='/dashboard/rm' element={<Layout><RM /></Layout>} />
          <Route path='/rmlist' element={<Layout><RMList /></Layout>} />
          <Route path='/rmedit/:id' element={<Layout><RMEdit /></Layout>} />

          <Route path='/dashboard/citpm' element={<Layout><CITPM /></Layout>} />
          <Route path='/citpm_list' element={<Layout><CITPMLIST /></Layout>} />
          <Route path='/citpm_edit/:CITPM_PolicyID' element={<Layout><CitpmEdit /></Layout>} />

          <Route path='/dashboard/lgcm' element={<Layout><LGCM /></Layout>} />
          <Route path='/lgcmlist' element={<Layout>< LGCMList /></Layout>} />
          <Route path='/lgcmedit/:LGCM_ID' element={<Layout><LGCMEdit /></Layout>} />

          <Route path='/dashboard/Locationmaster' element={<Layout><LocationMaster /></Layout>} />
          <Route path='/dashboard/Locationmasteredit/:LCM_ID' element={<Layout><LocationMasterEdit /></Layout>} />
          <Route path="/dashboard/Locationmasterlist" element={<Layout><LocMasterList /></Layout>} />
          {/* Shipment Outward Creation */}
          <Route path="/dashboard/shipment" element={<Layout><ShipmentForm /></Layout>} />
          <Route path="/shipmentlist" element={<Layout><ShipmentList /></Layout>} />
          <Route path="/shipmentedit/:shipmentCode" element={<Layout><ShipmentEdit /></Layout>} />
          <Route path="/shipmentview/:shipmentCode" element={<Layout><ShipmentDetail /></Layout>} />
          {/* //order master */}

          <Route path='/dashboard/ordermaster' element={<Layout><OrderForm /></Layout>} />
         
        
          <Route path='/dashboard/OrdView/:ORDM_OrderNumber' element={<Layout><OrdView></OrdView></Layout>} />
          {/* <Route path='/' element={<EditPopup />} /> */}
          <Route path='/dashboard/OrderList' element={<Layout><OrderList /></Layout>} />
          
          <Route path="/dashboard/editorder/:ORDM_OrderNumber" element={<Layout><EditOrderList /></Layout>} />
         

          <Route path="/dashboard/shipmentreturn" element={<Layout><ShipmentReturn /></Layout>} />
          <Route path="/shipmentreturnlist" element={<Layout><ShipmentReturnList /></Layout>} />
          <Route path="/shipmentreturnedit/:shipmentCode" element={<Layout><ShipmentReturnUpdate /></Layout>} />
          <Route path="/shipmentreturnview/:shipmentCode" element={<Layout><ShipmentReturnView /></Layout>} />

          {/* Reports */}
          <Route path='/dashboard/OrderReport' element={<Layout><OrderReport></OrderReport></Layout>}></Route>

          <Route path="/dashboard/shipmentreport" element={<Layout><ShipmentReportTable /></Layout>} />
          <Route path='/dashboard/Auditreport' element={<Layout><AuditTrailReport /></Layout>}></Route>

          {/* ////===================== Shipment Scanning Process (UPDATED) =====================//// */}
          <Route path='/dashboard/ShipmentSelectScanType' element={<Layout><ShipmentSelectScanType /></Layout>} />
          <Route path='/ShipInScanSearch' element={<Layout><ShipInScanSearch /></Layout>} />
          <Route path='/ShipInScanPendingList' element={<Layout><ShipInScanPendingList /></Layout>} />
          <Route path='/ShipInScanByVendor/:SHPH_ShipmentID' element={<Layout><ShipInScanByVendor /></Layout>} />
          <Route path='/ShipInScanByProduct/:SHPH_ShipmentID' element={<Layout><ShipInScanByProduct /></Layout>} />
          <Route path='/ShipInScanedList/' element={<Layout><ShipInScanedList /></Layout>} />
          <Route path='/ShipOutScanSearch' element={<Layout><ShipOutScanSearch /></Layout>} />
          <Route path='/ShipOutScanPendingList' element={<Layout><ShipOutScanPendingList /></Layout>} />
          <Route path='/ShipOutScanByVendor/:SHPH_ShipmentID' element={<Layout><ShipOutScanByVendor /></Layout>} />
          <Route path='/ShipOutScanByProduct/:SHPH_ShipmentID' element={<Layout><ShipOutScanByProduct /></Layout>} />
          <Route path='/ShipOutScanedList' element={<Layout><ShipOutScanedList /></Layout>} />


          <Route path='/ShipInReturnScan/:SHPR_ShipmentID' element={<Layout><ShipInReturnScan /></Layout>} />
          {/* <Route path='/ShipOutReturnScan/:SHPR_ShipmentID' element={<Layout><ShipOutReturnScan /></Layout>} /> */}
          <Route path='/ShipOutReturnScan/:SHPR_ShipmentID' element={<Layout><ShipOutReturnScan /></Layout>} />




          {/* ////===================== Shipment Scanning Process (UPDATED) =====================//// */}

          {/* Rights folder */}
          <Route path='/dashboard/OrderVerification' element={<Layout><OrderVerification /></Layout>} />
          <Route path='/dashboard/EditOrderStatus/:ORDM_OrderNumber' element={<Layout><EditOrderStatus /></Layout>} />


          {/* E-mail Configuration */}
          <Route path="/dashboard/EmailConfiguration" element={<Layout><EmailConfiguration /></Layout>} />
          <Route path="/EmailConfigurationList" element={<Layout><List /></Layout>} />
          <Route path="/EmailConfigurationedit/:id" element={<Layout><EmailEdit /></Layout>} />


          {/* RSN HISTORY REPORT */}

          <Route path='/dashboard/RsnHistory' element={<Layout><Rsn /></Layout>} />


          <Route path='/dashboard/SupplyChainTransaction' element={<Layout><SCT /></Layout>} />
            <Route path="/supply-chain-map/:rsnNumber" element={<FullScreenSupplyChainMap />} />
          
                    <Route path="/SchemeMaster" element={<Layout><SchemeMaster /></Layout>} />
          <Route path="/SchemeMaster/:schemeId" element={<Layout><SchemeMaster /></Layout>} />
          <Route path="/SchemeList" element={<Layout><SchemeList /></Layout>} />
          

    
          <Route path="/dashboard/companyconfig" element={<Layout><CCHome /></Layout>} />
          <Route path="/dashboard/companyconfig/:id" element={<Layout><CCHome /></Layout>} />
          <Route path="/dashboard/ccview" element={<Layout><CCView /></Layout>} />
          <Route path="/cclist" element={<Layout><CCList /></Layout>} />

        </Routes>
      </UserProvider>
    </div>

  );
}

export default App;

